<div class="flex flex-col">
    <div class="flex flex-0 sticky top-0 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{ 'services.dialog.editUserEvents.title' | transloco }} - {{ userName() }}</div>
        <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>

    <div class="w-full flex flex-col p-8">
        <h2 class="text-lg font-semibold">{{ 'services.dialog.editUserEvents.checkin' | transloco }}</h2>
        <div class="flex w-2/3 items-center py-4">
            <mat-form-field class="fuse-mat-no-subscript w-1/2 h-24">
                <mat-label>{{ 'services.dialog.editUserEvents.date' | transloco }}</mat-label>
                <input #checkInInput="ngModel" [(ngModel)]="checkIn" matInput [matDatepicker]="checkinPicker" required readonly (click)="openDatepickerOnClick(checkinPicker)">
                <mat-datepicker-toggle matIconSuffix [for]="checkinPicker"></mat-datepicker-toggle>
                <mat-datepicker #checkinPicker></mat-datepicker>
                @if (checkInInput.invalid && checkInInput.touched) {
                    <mat-error class="ml-3">
                        {{ 'errorRequiredField' | transloco }}
                    </mat-error>
                }
            </mat-form-field>
            <div class="flex flex-col items-center w-1/2 h-24">
                <mat-label class="mb-2">{{ 'services.dialog.editUserEvents.time' | transloco }} *</mat-label>
                <ngb-timepicker #checkinTimepicker #checkinTimeModel="ngModel" [(ngModel)]="checkInTime" (ngModelChange)="timeChanged(checkinTimepicker, checkInTime())" required [spinners]="false"></ngb-timepicker>
                @if (checkinTimeModel.invalid && checkinTimeModel.touched) {
                    <mat-error class="ml-3">
                        {{ 'errorRequiredField' | transloco }}
                    </mat-error>
                }
            </div>
        </div>  
        
        <h2 class="text-lg font-semibold">{{ 'services.dialog.editUserEvents.checkout' | transloco }}</h2>
        <div class="flex w-2/3 items-center py-4">
            <mat-form-field class="fuse-mat-no-subscript w-1/2 h-24">
                <mat-label>{{ 'services.dialog.editUserEvents.date' | transloco }}</mat-label>
                <input #checkOutInput="ngModel" [(ngModel)]="checkOut" matInput [matDatepicker]="checkoutPicker" required readonly (click)="openDatepickerOnClick(checkoutPicker)">
                <mat-datepicker-toggle matIconSuffix [for]="checkoutPicker"></mat-datepicker-toggle>
                <mat-datepicker #checkoutPicker></mat-datepicker>
                @if (checkOutInput.invalid && checkOutInput.touched) {
                    <mat-error class="ml-3">
                        {{ 'errorRequiredField' | transloco }}
                    </mat-error>
                }
            </mat-form-field>
            <div class="flex flex-col items-center w-1/2 h-24">
                <mat-label class="mb-2">{{ 'services.dialog.editUserEvents.time' | transloco }} *</mat-label>
                <ngb-timepicker #checkoutTimepicker #checkoutTimeModel="ngModel" [(ngModel)]="checkOutTime" (ngModelChange)="timeChanged(checkoutTimepicker, checkOutTime())" required [spinners]="false"></ngb-timepicker>
                @if (checkoutTimeModel.invalid && checkoutTimeModel.touched) {
                    <mat-error class="ml-3">
                        {{ 'errorRequiredField' | transloco }}
                    </mat-error>
                }
            </div>
        </div>
        <div class="flex w-1/2 justify-between py-4 gap-4">
            <timeconverter-component class="w-1/2" [control]="workTime" label="{{ 'services.dialog.editUserEvents.workTime' | transloco }}" [required]="true"></timeconverter-component>
            <timeconverter-component class="w-1/2" [control]="pauseTime" label="{{ 'services.dialog.editUserEvents.pauseTime' | transloco }}" [required]="true"></timeconverter-component>
        </div>

        <div class="flex flex-row justify-end pt-4">
            <button mat-flat-button class="mr-8" color="warn" (click)="closeDialog()">{{ 'cancel' | transloco }}</button> 
            <button mat-flat-button class="mr-8" color="primary" [disabled]="checkInInput.invalid || checkinTimeModel.invalid || checkOutInput.invalid || checkoutTimeModel.invalid || workTime.invalid || pauseTime.invalid" (click)="save()">{{ 'save' | transloco }}</button> 
        </div>
    </div>

</div>
